import App from "../../../vendor_core/core/src/App";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import ShowWinState from "../../../vendor_core/core/src/states/ShowWinState";
import Utils from "../../../vendor_core/core/src/utils/Utils";
import BURFeatureModel from "../models/BURFeatureModel";

export default class BURShowWinState extends ShowWinState {
    public displayWin(): void {
        super.displayWin();
        if (!SpinModel.hasBigWin()) {
            CommandManager.execute(Commands.UPDATE_WIN);
        }

        // SoundController.playSound(`multi_${currentMultiplier}`);
    }
    protected getUnlockTime(): number {
        // By default we unlock the spin button immediately.
        let delay = 0;
        const hasBlueReplay = BURFeatureModel.blue_respin_data !== undefined;
        if (
            SpinModel.hasBigWin() ||
            SpinModel.isInFreespins() ||
            SpinModel.isInRespins() ||
            SpinModel.inFreegames() ||
            AutoplayModel.isAutoSpinActive() ||
            SpinModel.freespinsWon > 0 ||
            hasBlueReplay
        ) {
            // But since we have a feature, we hold the spin button locked for a while.
            delay = Utils.isNumeric(App.config.showWinUnLockTime)
                ? Number(App.config.showWinUnLockTime)
                : 1.5;
        }
        return delay;
    }
}
